<template>
  <div>
    <el-button data-testid="view-criteria" :plain="true" size="mini" @click="viewRulesetsForCase()">
      <span style="display:flex; gap: .5rem; align-items: center;">
        View criteria
        <Icon :iconKey="'blocks'" :description="'View all relevent rulesets'" />
      </span>
    </el-button>

    <div ref="dialogContainer">
      <el-dialog title="View Criterion" v-model="showRulesetDialog" :close-on-click-modal="false"
        :close-on-press-escape="false" :show-close="false">
        <div style="overflow: auto; max-height: 65vh; padding: 0 1rem 0 0;">
          <RulesetViewer :data="selectedCaseToViewRuleset" />
        </div>
        <div class="dialog-footer">
          <el-button data-testid="close-criteria" @click="showRulesetDialog = false">Close</el-button>
        </div>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import RulesetViewer from "../Shared/RulesetViewer.vue"
import Icon from "../Shared/Icon.vue"

export default {
  name: "RulesetViewerTrigger",
  components: {
    Icon,
    RulesetViewer
  },
  props: {
    caseId: {
      type: Number,
      default: null
    }
  },
  data() {
    return {
      selectedCaseToViewRuleset: null,
      showRulesetDialog: false
    };
  },
  computed: {},
  methods: {
    async viewRulesetsForCase() {
      const ruleset = await this.$http.get(`${window.CONFIG.infection_api}/rules/${this.caseId}`, {}).then(resp => resp.json())
      this.selectedCaseToViewRuleset = ruleset;
      this.showRulesetDialog = true;
    }
  },
  async mounted() {
    if (this.$refs.dialogContainer) {
      document.body.append(this.$refs.dialogContainer);
    }
  }
};
</script>

<style scoped></style>
